exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".admin-layout[data-v-41f1e8a0]{height:100vh}.admin-aside[data-v-41f1e8a0]{background:#001529;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}.admin-logo[data-v-41f1e8a0]{color:#fff;font-size:20px;font-weight:700;text-align:center;padding:18px 0;border-bottom:1px solid hsla(0,0%,100%,.1)}.admin-menu[data-v-41f1e8a0]{-ms-flex:1;flex:1;border-right:none;overflow:auto}.admin-aside-foot[data-v-41f1e8a0]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:12px 16px;border-top:1px solid hsla(0,0%,100%,.1)}.admin-username[data-v-41f1e8a0]{color:hsla(0,0%,100%,.85);font-size:13px}.admin-logout[data-v-41f1e8a0]{color:#ffd04b!important}.admin-main[data-v-41f1e8a0]{background:#f0f2f5;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41f1e8a0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/layouts/AdminLayout.vue
// module id = 146
// module chunks = 0